import React from 'react';
import PropTypes from 'prop-types';
import {Button, buttonTypes} from '../../../components/Button';
import Input from '../../../components/Input';


class ResetPassword extends React.Component {
  state = {
    email: '',
    error: {},
  };

  componentWillMount() {
    this.setState({email: this.props.email})
  }

  componentWillReceiveProps(next) {
    this.setState({error: {...next.error}})
  }

  handleChange(e) {
    const {value} = e.target;
    if (value.length > 1000) {
      this.setState({error: {email: 'Max length 1000 characters'}})
    } else {
      this.setState({
        email: value
      }, () => {
        this.setState({error: {email: ''}})
      });
    }
  }

  sendEmail = () => {
    const {email} = this.state;
    if (!email) {
      this.setState({error: {email: 'Add email'}});
    } else
      this.props.sendEmail({email})
  };

  render() {

    const {
      email,
      error
    } = this.state;

    return (
      <div className="modal__wrap">
        <header>
          <h3 className="modal__title">Reset password</h3>
          <p className="modal__description">Please enter your email</p>
        </header>
        <Input
          type="text"
          label="E-mail address"
          placeholder="Email"
          value={email}
          name="email"
          error={error.email}
          onChange={(e) => this.handleChange(e)}
        />

        <footer>
          <Button
            type={buttonTypes.AUTHENTICATION}
            name="Send"
            onClick={() => this.sendEmail()}
            disabled={error.email && true}
          />
        </footer>
      </div>
    )
  }
}

ResetPassword.propTypes = {
  email: PropTypes.string,
  sendEmail: PropTypes.func,
};

export default ResetPassword


// WEBPACK FOOTER //
// ./src/app/containers/Auth/components/resetPasword.js